// extracted by mini-css-extract-plugin
export var dot1 = "styles-module--dot1--9a058";
export var dot2 = "styles-module--dot2--cb5e2";
export var dot3 = "styles-module--dot3--980d9";
export var ripple = "styles-module--ripple--9c84a";